import { SystemCssProperties } from '@mui/system/styleFunctionSx/styleFunctionSx';

import { CALENDAR_GRID_DEFAULTS } from '../../constants';

export const getCalendarGridStyle = (
  gridColor: string = CALENDAR_GRID_DEFAULTS.gridColor,
  border?: Record<string, number | undefined>,
): SystemCssProperties => ({
  backgroundColor: gridColor,
  ...['right', 'left', 'top', 'bottom'].reduce((styles, v) => {
    if (!border || typeof border[v] === 'undefined') return styles;
    const borderKey = `border${v[0].toUpperCase()}${v.slice(1)}`;
    styles = {
      ...styles,
      [borderKey]: `${border[v]}px solid ${gridColor}`,
    };
    return styles;
  }, {}),
});
